export type SocialAuthProviderId = 'github' | 'google' | 'microsoft';

const SOCIAL_AUTH_REDIRECT_HOSTS: Record<SocialAuthProviderId, readonly string[]> = {
  github: ['github.com'],
  google: ['accounts.google.com'],
  microsoft: ['login.microsoftonline.com', 'login.live.com', 'login.microsoft.com'],
};

export function verifiedSocialAuthRedirectUrl(
  provider: SocialAuthProviderId,
  value: string,
  currentOrigin =
    typeof window === 'undefined' ? 'https://app.perspectify.dev' : window.location.origin
): string {
  const redirect = new URL(value, currentOrigin);

  if (redirect.origin === currentOrigin && redirect.pathname.startsWith('/api/auth/ba/')) {
    return redirect.toString();
  }

  if (
    redirect.protocol === 'https:' &&
    SOCIAL_AUTH_REDIRECT_HOSTS[provider].includes(redirect.hostname.toLowerCase())
  ) {
    return redirect.toString();
  }

  throw new Error(`Unexpected ${provider} authentication redirect.`);
}

export function redirectToSocialAuth(provider: SocialAuthProviderId, value: string): void {
  window.location.assign(verifiedSocialAuthRedirectUrl(provider, value));
}

export function normalizeHttpUrl(
  value: string,
  baseUrl =
    typeof window === 'undefined' ? 'https://app.perspectify.dev/' : window.location.href
): string | null {
  try {
    const url = new URL(value, baseUrl);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}
